import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="bg-white py-24 sm:py-32" data-id="element-169">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-170">
        <div className="mx-auto max-w-3xl text-center mb-16" data-id="element-171">
          <FadeIn data-id="element-172">
            <h2 className="font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl" data-id="element-173">
              The "Witching Hour" Is Real — And It's Not Your Fault
            </h2>
          </FadeIn>
        </div>

        <div className="mx-auto max-w-3xl" data-id="element-174">
          <FadeIn delay={0.2} data-id="element-175">
            <div className="relative border-l-4 border-amber bg-cream-dark/30 px-8 py-10 rounded-r-2xl shadow-sm" data-id="element-176">
              <p className="text-xl text-navy-light leading-relaxed font-medium mb-6" data-id="element-177">
                The "Witching Hour" is the hardest part of a mother's day for a
                biological reason: your child's nervous system is hitting a wall
                just as your own patience is running out.
              </p>
              <p className="text-lg text-muted leading-relaxed" data-id="element-178">
                Most "activity ideas" fail because they require too much setup,
                too much parental supervision, or they don't match your child's
                actual energy level. You end up working harder to entertain them
                than you would have if you'd just let them watch TV, and the
                "screen hangover" irritability afterward makes bedtime even
                harder.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}